export default __webpack_public_path__ + "12d211a5.jpg";